<!-- 게시판글 표현 -->
<template>
    <div class="wrapper">
        <template v-if="getYoutube(post.content)">
            <div  class="youtube" >
                <iframe :src="`https://www.youtube.com/embed/${getYoutube(post.content)}?autoplay=1&mute=1&loop=1`"
                style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
                </iframe>
            </div>
        </template>
        <template v-else>
            <div class="thumb" @click="updateCount(post.id, post.document.menu, post.document.name)">
                <div :style="{backgroundImage:'url('+ getImage(post.content)+')'}" class="thumb_box" v-if="getImage(post.content)"></div>
                <div v-else class="thumb_box" 
                    :style="{backgroundImage:`url(${require('@/assets/imgs/no_image.png')})`}">             
                </div>   
                <!-- <div v-else class="thumb_box">
                    게임조아
                    <span>No Image</span>
                </div>            -->
            </div>
        </template>

        <div class="cont" v-if="isTitleView && !isYoutube">
            <div class="title">
               <span v-if="isDocView">[{{post.document.title}}]</span> <post-title :document="post.document.name" :list="post" :menu="post.document.menu"/>
            </div>
            <!-- <div class="content">
                {{getCont(post.content)}}
            </div> -->
            <!--
            <div class="created_at">
                <display-time :time="post.created_at" :type="1" />
            </div>
            -->
        </div>

    </div>
    <!-- <div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">
    <iframe src="https://www.youtube.com/embed/E1ID7l1l6tA"
        style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
        frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
    </iframe>
</div> -->    
  
</template>
<script>
import { removeAllTag } from '@/utils/removetag';
//import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import PostTitle from '@/components/posts/PostTitle.vue';
import { postLink } from '@/utils/menu';
export default {
    props:{
        post: {            
            required: true,
            default: null
        },
        isTitleView: {
            required: false,
            default:true,    
        },
        isDocView: {
            required: false,
            default: false,    
        }
    },
    data()
    {
        return{
            isYoutube:false
        }
    },
    components:{
        //DisplayTime,
        PostTitle
    },
    methods:{
        getYoutube(cont){
            //유투브영상 체크
            const step1 = cont.split('https://youtu.be/');
            if ( step1.length === 1)
            {
                return false;
            }
            //게시판 구분, 게임등급&질의, 멘토리, 뉴스,이슈 게시판만
            const allow =[4,5,6,7,8,9,10,11,12,13,14,26,29];
            if(!allow.includes(this.post.document_id))
            {
                return false;
            }
            const step2 = step1[1].split('">')
            this.isYoutube = true;
            return step2[0];
        },
        getImage(cont)
        {
            const step1 = cont.split('<img src="')
            if ( step1.length === 1)
            {
                return '';
            }
            const step2 = step1[1].split('">')
            //웹에서 긁어온 이미지때문에 한번더 파싱
            const step3= step2[0].split('" ')
            return step3[0];
        },
        getCont(cont)
        {
            const removetag = removeAllTag(cont);
            return removetag.substr(0, 60) + (removetag.length >60?'...':'') ;
        },
        updateCount(post_id,menu_title,document)
        {
            const menu = this.$store.getters['menu/getMenu'].find((menus)=>menus.title === menu_title).name;
            postLink(post_id,menu,document,this.$store);   
            this.$router.push({
                path: "/main/community/" + menu +"/"+document+"/view/"+post_id                
            }); 
        }

    }
}
</script>
<style lang="scss" scoped>
.wrapper
{    
    display:flex;
    .youtube{
        width:250px;             
        position: relative; 
        padding-bottom: 100%;   
        height: 0;   
        padding-bottom: 56.2493%;   
    }
    .thumb{
        cursor:pointer;
        .thumb_box{
            width:150px; height:120px;
            background-size:cover;
            background-color:#dee3eb;
            color:#808080;
            display:flex;
            align-items:center;
            justify-content: center;
            font-size:16px;
            flex-direction:column;
            span{
                font-size:11px;
                background:#808080;
                border-radius:10px;
                color:#dee3eb;
                padding:0 5px;
            }
        }
    }
    .cont{
        padding-left:20px;
        font-family:malgungothic;
        .title{
            margin-top:10px;
            font-weight:bold;
        }
        .content{
            margin-top:20px;
            padding-right:20px;
            line-height:20px;
        }
        .created_at{
            margin-top:20px;
        }
    }
}
</style>
